__turbopack_context__.v({
  "className": "jetbrains_mono_ebf4a1f1-module__LwDBYq__className",
  "variable": "jetbrains_mono_ebf4a1f1-module__LwDBYq__variable",
});
